require('./bootstrap');
import Vue from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue';
import BootstrapVue from 'bootstrap-vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue';
import { Ziggy } from './ziggy';
import { InertiaLink } from '@inertiajs/inertia-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrashCan, faCamera } from '@fortawesome/free-solid-svg-icons';
import Vue2Editor from 'vue2-editor';
import Toast from 'vue-toastification';
import VueQRCodeComponent from 'vue-qrcode-component';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';
import vClickOutside from 'v-click-outside';

Vue.use(vClickOutside);
const options = {
    position: 'top-right',
    timeout: 3000,
};

import helper from './services/helper';
window.helper = helper;
var Paginate = require('vuejs-paginate');

Vue.use(Vue2Editor);
Vue.use(BootstrapVue);
Vue.use(ZiggyVue, Ziggy);
Vue.use(Toast, options);
library.add(faTrashCan, faCamera);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('InertiaLink', InertiaLink);
Vue.component('paginate', Paginate);
Vue.component('qr-code', VueQRCodeComponent);
Vue.mixin({
    methods: {
        hasAnyPermission: function (permissions) {
            var allPermissions = this.$page.props.auth.can;
            var hasPermission = false;
            permissions.forEach(function (item) {
                const check = allPermissions.find(data => item === data);
                if (check) hasPermission = true;
            });
            return hasPermission;
        },
    },
});
createInertiaApp({
    resolve: component => {
        let parts = component.split('::');
        let type = false;
        if (parts.length > 1) type = parts[0];
        if (type) {
            return import(`../../Modules/${type}/Resources/assets/js/Pages/${parts[1]}.vue`).then(module => module.default);
        } else {
            return import(`./Pages/${component}`).then(module => module.default);
        }
    },
    setup({ el, app, props }) {
        new Vue({
            render: h => h(app, props),
        }).$mount(el);
    },
});
